<template>
<div class="chapter">
<div class="inner_page">
<div class="titlePage" id="tp01">
<a id="page01">
</a><a id="page02">
</a><a id="page03">
<h2 class="titlePageAuthor">Lewis M. Cohen, MD</h2>
<h2 class="titlePageTitle">No Good Deed</h2>
<p class="titlePageSubtitle">A Story of Medicine, Murder Accusations, and the Debate over How We Die</p>
<p class="colophon"><img alt="image" src="Images/logo.jpg"/></p>
</a></div>
<a id="page03">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002titlepage.vue?28156ef5